// extracted by mini-css-extract-plugin
var _1 = "V7_EnoqW81QlA8NFZgcl";
var _2 = "V7_EnoqW81QlA8NFZgcl";
var _3 = "QjUHxCrXhoEh1jKHLCoP";
export { _1 as "browser-info", _2 as "browserInfo", _3 as "name" }
